import { render, staticRenderFns } from "./AccionesPedidoDialogo.vue?vue&type=template&id=28fb51b0"
import script from "./AccionesPedidoDialogo.vue?vue&type=script&lang=js"
export * from "./AccionesPedidoDialogo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports